import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// On an expired access token, refresh once (rotates both cookies) and retry the original request.
const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/verify-email", "/auth/reset-password", "/auth/google"];
let refreshing = null;
api.interceptors.response.use(undefined, async (error) => {
  const { config, response } = error;
  if (!config || response?.status !== 401 || config._retried || NO_REFRESH.some((p) => config.url?.includes(p))) throw error;
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  try { await refreshing; } catch { throw error; }
  return api({ ...config, _retried: true });
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
